<div class="show-message">
    <app-centered-scrollable-content>

      <sc-flex [vertical]="true" [centered]="true" [fitHeight]="true">
        <ng-container *ngIf="validationMessages != null && validationMessages.length > 0">
          <h2 *ngFor="let msg of validationMessages">
            {{msg.message | translate: [msg.message, translationService.language]}}
          </h2>
        </ng-container>
      </sc-flex>

    </app-centered-scrollable-content>
</div>
